import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import OnboardingNavbarPicker from 'Views/Onboarding/Components/OnboardingNavbarPicker';
import useMobileLayout from 'Hooks/useMobileLayout';
import { dataAttrs } from 'Helpers/Testing';
import Modal from 'Views/Page/Content/Modal';
import SurveyHeader from '../SurveyHeader';
import SurveyFooter from '../SurveyFooter';
import SurveyContentBody from '../SurveyContentBody';
import { useSurveyContext } from '../SurveyContext';

const styles = (theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 'auto',
  },
  rootMobile: {
    maxWidth: theme.dimensions.md,
  },
  rootDesktop: {
    maxWidth: theme.dimensions.lg,
  },
  rootDesktopXl: {
    maxWidth: theme.dimensions.xl,
  },
  footer: {
    width: 'inherit',
  },
});

const FULL_WIDTH_STEP_MAP = {
  onboardingIncomeSalaryPayStubDetails: true,
};

const XL_WIDTH_STEP_MAP = {
  onboardingGoalSummary: true,
  onboardingGoalPriority: true,
  onboardingRecurringExpenseFrequencies: true,
  onboardingRecurringExpenseAmounts: true,
  onboardingExpenseSummary: true,
  onboardingAssetsAndLiabilitiesAdd: true,
  onboardingAssetsAndLiabilitiesSummary: true,
  onboardingOneTimeExpenses: true,
  onboardingBuyAPropertyStep: true,
  onboardingSaveForEducationStep: true,
  onboardingCustomGoalStep: true,
  onboardingPlannerAssignmentSelectPlanner: true,
};

export const isDigitalOnboardingStepContentDrivenByLayout = (resource) => {
  if (!resource) {
    return false;
  }

  return FULL_WIDTH_STEP_MAP[resource.type()];
};

export const isDigitalOnboardingStepContentXlWidth = (resource) => {
  if (!resource) {
    return false;
  }

  return XL_WIDTH_STEP_MAP[resource.type()];
};

const SurveyContent = ({
  className,
  classes,
  clientResource,
}) => {
  const {
    surveyModuleTitle,
    showNavbar,
    showHeader,
    onboardingStepResource,
  } = useSurveyContext();
  const isMobile = useMobileLayout();

  const isFullWidth = isDigitalOnboardingStepContentDrivenByLayout(onboardingStepResource);
  const isExtraLargeWidth = isDigitalOnboardingStepContentXlWidth(onboardingStepResource);


  return (
    <React.Fragment>
      {showNavbar ? <OnboardingNavbarPicker clientResource={clientResource} /> : null}
      <Box
        className={classNames(classes.root, className, {
          [classes.rootMobile]: isMobile && !isFullWidth,
          [classes.rootDesktop]: !isMobile && !isFullWidth && !isExtraLargeWidth,
          [classes.rootDesktopXl]: !isMobile && !isFullWidth && isExtraLargeWidth,
        })}
        test={'survey-content-root'}
        {...dataAttrs('onboarding-step', onboardingStepResource)}
      >
        {showHeader ? (<SurveyHeader
          title={surveyModuleTitle}
          clientResource={clientResource}
        />) : null}
        <SurveyContentBody />
        <SurveyFooter className={classes.footer} />
        <Modal />
      </Box>
    </React.Fragment>
  );
};

SurveyContent.defaultProps = {
  className: '',
};

SurveyContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  clientResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(SurveyContent);
